import { RuleActionType } from '../enumerations/rule-action-type'

export interface RuleAction {
	type:RuleActionType
	details:any
}